import { render, staticRenderFns } from "./to-comment.vue?vue&type=template&id=4565d2c4&"
import script from "./to-comment.vue?vue&type=script&lang=js&"
export * from "./to-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports